module.exports = __webpack_public_path__ + "assets/images/rbyearend-03-desktop.jpg?v=c30b14ce";